import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { LocalStorageService } from 'angular-2-local-storage';
import { APP } from '../constants';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
  })
export class AuthService {
    apiEndpoint = APP.ApiEndpoint;

    constructor(
        private http: HttpClient,
        private router: Router,
        private _LocalStorageService: LocalStorageService
    ) { }

    public Login(data: any, callback) {
        const url = `${this.apiEndpoint}/api/auth/login/`;
        return this.http.post(url, data)
        .subscribe(
            result => { callback(result); }
        );
    }

    public logout() {
        this._LocalStorageService.remove('tokenUserActive');
        this.router.navigate(['login']);
    }

    public isAuthenticated() {
        const token = this._LocalStorageService.get('tokenUserActive');
        return token != null;
    }

    public isAuthorized(path) {
        const url = `${this.apiEndpoint}/api/auth/isAuthorized/`;
        const token = this._LocalStorageService.get('tokenUserActive');
        const data = {
            token: token,
            path: path
        };
        return this.http.post(url, data).pipe(map((res: any) => res));
    }

    public cargarDataUsuario(data: any, callback) {
        const url = `${this.apiEndpoint}/api/auth/getInfoAuth/`;
        const token = this._LocalStorageService.get('tokenUserActive');
        data = { token: token };
        return this.http.post(url, data).subscribe(
            result => { callback(result); }
        );
    }
}